import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Row = styled.div`
  margin-bottom: 24px;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const Day = styled.p`
  margin: 0;
  flex: 1;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.textGrey};
`;

export const DateLabel = styled.button<{
  isSelected: boolean;
  isToday: boolean;
  disabled: boolean;
}>`
  appearance: none;
  border: none;
  outline: none;
  display: grid;
  transition: none;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0;
  z-index: 1;
  flex: 1;
  text-align: center;
  font-size: 14px;
  height: 14px;
  line-height: 14px;

  &:hover {
    cursor: pointer;
  }

  p {
    transition: none;
    position: absolute;
    margin: 0;
    text-align: center;
    width: 100%;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
    `}

  ${({ isSelected, isToday, theme }) =>
    (isSelected || isToday) &&
    css`
      color: ${theme.colors.white};

      &:before {
        content: '';
        z-index: 0;
        position: absolute;
        background-color: ${({ theme }) => theme.colors.lightBlue};
        width: 35px;
        height: 35px;
        border-radius: 35px;
        top: -12.5px;
        left: 2.5px;

        ${isToday &&
        !isSelected &&
        css`
          opacity: 0.5;
        `}
      }
    `}
`;
